/* ============
 * French Language File
 * ============
 *
 */

import * as startPage from './startPage.json'
import * as nav from './nav.json'
import * as deals from './deals.json'
import * as deal from './deal.json'
import * as charts from './charts.json'
import * as surveys from './surveys.json'
import * as transactions from './transactions.json'
import * as contactUs from './contactUs.json'

export default {
  startPage,
  nav,
  deal,
  deals,
  charts,
  surveys,
  transactions,
  contactUs
}



// WEBPACK FOOTER //
// ./src/app/locale/fr/index.js